import TopBar from './TopBar.vue'

export default TopBar
